export interface ExpectationFieldMapping {
  actualField: string;
  targetField: string;
  statusField: string;
}

/**
 * Resolves the actual/target/status triple for a bonus dataset field from the
 * program's criteria/qualifier/disqualifier field mappings. A field matches
 * whether it is the metric field (`actualField`) or its target (`targetField`),
 * so a caller can pass either and get the same pair back. Returns undefined when
 * the field has no expectation mapping (e.g. a plain pay field).
 *
 * Shared by BonusExpectationCell (board grid) and the sub-period fact table so
 * both resolve targets identically.
 */
const resolveExpectationField = ({
  program,
  field,
}: {
  program: BonusTypes.BonusProgram | undefined;
  field: string;
}): ExpectationFieldMapping | undefined => {
  if (!program) {
    return undefined;
  }

  const allFields = [
    ...program.criteriaFields,
    ...(program.qualifierFields ?? []),
    ...(program.disqualifierFields ?? []),
  ];

  const match = allFields.find(
    (f) => f.actualField === field || f.targetField === field,
  );

  if (!match) {
    return undefined;
  }

  const { actualField, targetField, statusField } = match;
  return { actualField, targetField, statusField };
};

export default resolveExpectationField;
